import { canEditBoundaries, producerFinishedDataCollection, producerStatusAhead } from './field/field-helper';
import { API } from '../../../service/common/api';
import { CONTRACT_URL, ESTIMATE_URL, FIELD_URL } from '../../../service/common/env';
import DrawControl from '../../../pages/map/components/Map/DrawControl';

export const getMapState: any =
  (
    fields: any[],
    shapefileStatus: string,
    country: string,
    producerData: any,
    isChannelPartner: boolean,
    brFinalizeBoundaries: boolean,
    shouldLdAllowBoundaryEdit: boolean,
  ) =>
  (dispatch: any) => {
    const layout = fields?.length && fields[0]?.layout;
    if (layout) {
      dispatch({
        type: 'SET_LAYOUT',
        payload: layout,
      });
    }

    if (country === 'br') {
      if (producerStatusAhead(producerData?.caseStatus, brFinalizeBoundaries)) {
        dispatch({
          type: 'SET_MAP_STATE',
          payload: 'OVERVIEW_V2',
        });
      } else {
        dispatch({
          type: 'SET_MAP_STATE',
          payload: 'FIRST_SETUP',
        });
      }
    } else {
      dispatch({
        type: 'ENABLE_FINALIZE',
      });
      if (shouldLdAllowBoundaryEdit || canEditBoundaries(producerData, fields, layout, isChannelPartner, shapefileStatus)) {
        dispatch({
          type: 'SET_MAP_STATE',
          payload: 'FIRST_SETUP',
        });
      } else if (producerFinishedDataCollection(shapefileStatus, layout, producerData) || (fields?.length && layout)) {
        dispatch({
          type: 'SET_MAP_STATE',
          payload: 'OVERVIEW_V2',
        });
      } else {
        dispatch({
          type: 'SET_MAP_STATE',
          payload: 'OVERVIEW',
        });
      }
    }
  };

export const setShowCloserFields: any = (showCloserFields: boolean) => (dispatch: any) => {
  dispatch({
    type: 'SHOW_CLOSER_FIELDS',
    payload: showCloserFields,
  });
};

export const getEstimate: any = (journeyId: string) => (dispatch: any) => {
  dispatch({
    type: 'GET_MAP_ESTIMATE_REQUESTED',
  });
  API.get(`${ESTIMATE_URL}/estimate-service/estimates/sync-state/${journeyId}`)
    .then((estimateResponse) => {
      dispatch({
        type: 'GET_MAP_ESTIMATE_SUCCEEDED',
        payload: estimateResponse.data,
      });
    })
    .catch((e) => {
      dispatch({
        type: 'GET_MAP_ESTIMATE_ERRORED',
        payload: e,
      });
    });
};

export const checkIfContractExists: any = (journeyId: string, estimateId: string) => (dispatch: any) => {
  dispatch({
    type: 'GET_CONTRACT_PAYMENT_OPTION_REQUESTED',
  });
  API.get(`${CONTRACT_URL}/contract-service/contract/${journeyId}/${estimateId}`)
    .then((contractResponse) => {
      dispatch({
        type: 'GET_CONTRACT_PAYMENT_OPTION_SUCCEEDED',
        payload: contractResponse.data?.data?.paymentOption,
      });
      if (contractResponse.data) {
        dispatch({
          type: 'ENABLE_FINALIZE',
        });
      }
    })
    .catch((e) => {
      dispatch({
        type: 'GET_CONTRACT_PAYMENT_OPTION_ERRORED',
        payload: e,
      });
    });
};

export const getContractVersion: any = (contractVersionId: string) => (dispatch: any) => {
  dispatch({
    type: 'GET_CONTRACT_VERSION_REQUESTED',
  });
  API.get(`${CONTRACT_URL}/contract-service/contract/contract-versions/${contractVersionId}`)
    .then((contractResponse) => {
      dispatch({
        type: 'GET_CONTRACT_VERSION_SUCCEEDED',
        payload: contractResponse.data,
      });
    })
    .catch((e) => {
      dispatch({
        type: 'GET_CONTRACT_VERSION_ERRORED',
        payload: e,
      });
    });
};

export const getContractInSF: any = (opportunityId: string) => (dispatch: any) => {
  dispatch({
    type: 'GET_CONTRACT_IN_SF_REQUESTED',
  });
  API.get(`${CONTRACT_URL}/contract-service/contract/salesforce/${opportunityId}`)
    .then((contractResponse) => {
      dispatch({
        type: 'GET_CONTRACT_IN_SF_SUCCEEDED',
        payload: contractResponse.data,
      });
    })
    .catch((e) => {
      dispatch({
        type: 'GET_CONTRACT_IN_SF_ERRORED',
        payload: e,
      });
    });
};

export const mapLoaded: any = (map: mapboxgl.Map) => (dispatch: any) => {
  dispatch({
    type: 'MAP_LOADED',
    payload: map,
  });
};

export const setDrawControl: any = (draw: DrawControl) => (dispatch: any) => {
  dispatch({
    type: 'SET_DRAW_CONTROL',
    payload: draw,
  });
};

export const restartDraw: any = () => (dispatch: any) => {
  dispatch({
    type: 'RESTART_DRAW',
  });
};

export const onDrawUpdate: any = (event: any) => (dispatch: any) => {
  dispatch({
    type: 'ON_DRAW_UPDATE',
    payload: event,
  });
};

export const onDrawModeChange: any = (mode: string) => (dispatch: any) => {
  dispatch({
    type: 'ON_MODE_CHANGE',
    payload: mode,
  });
};

export const setMode: any = (mode: string) => (dispatch: any) => {
  dispatch({
    type: 'SET_MODE',
    payload: {
      mode,
    },
  });
};

export const toggleTraining: any = () => (dispatch: any) => {
  dispatch({
    type: 'TOGGLE_IS_DRAWING_TRAINING',
  });
};

export const toggleRemove: any = (force?: boolean) => (dispatch: any) => {
  dispatch({
    type: 'TOGGLE_REMOVE_TREES',
    payload: force,
  });
};

export const toggleTrainingVisible: any = () => (dispatch: any) => {
  dispatch({
    type: 'TOGGLE_IS_TRAINING_VISIBLE',
  });
};

export const editTraining: any = (id: string, newClass: number) => (dispatch: any) => {
  dispatch({
    type: 'EDIT_TRAINING',
    payload: {
      id,
      newClass,
    },
  });
};

export const deleteTraining: any = (id: string) => (dispatch: any) => {
  dispatch({
    type: 'DELETE_TRAINING',
    payload: {
      id,
    },
  });
};

export const getTrainingRegions: any = (journeyId: string) => (dispatch: any) => {
  dispatch({
    type: 'GET_TRAINING_REQUESTED',
  });
  API.get(`${FIELD_URL}/field-service/classification/training/${journeyId}`)
    .then((result) => {
      dispatch({
        type: 'GET_TRAINING_SUCCEEDED',
        payload: result.data,
      });
    })
    .catch(() => {
      dispatch({
        type: 'GET_TRAINING_ERRORED',
      });
    });
};

export const clearData: any = () => (dispatch: any) => {
  dispatch({
    type: 'CLEAR_DATA',
  });
};
